import css from "./Client.module.css";

const Client = ({ children, onClick, type = "mobile", isTiny }) => {
  const images = {
    mobile: {
      src: "https://uxwing.com/wp-content/themes/uxwing/download/computers-mobile-hardware/mobile-phone-white-icon.png",
      alt: "mobile phone",
    },
  };
  return (
    <button
      className={`${css.button} ${isTiny ? css.isTiny : ""}`}
      onClick={onClick}
    >
      <img className={css.icon} src={images[type].src} alt={images[type].alt} />
    </button>
  );
};

export default Client;
